import { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Typography, Box, MenuItem
} from "@mui/material";
import AddTaskIcon from '@mui/icons-material/AddTask';
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api } from "../../services/api";
import { KanbanGrupo } from "../Configuracoes/ModalKanbanTarefa";

type Props = {
    open: boolean;
    onClose: () => void;
    onSaved: () => void;
};

export default function ModalNovaTarefaKanban({ open, onClose, onSaved }: Props) {
    const [openLoad, setOpenLoad] = useState(false);
    const [grupos, setGrupos] = useState<KanbanGrupo[]>([]);
    const [idGrupo, setIdGrupo] = useState<number | "">("");
    const [nomeInstancia, setNomeInstancia] = useState("");

    useEffect(() => {
        if (open) {
            setIdGrupo("");
            setNomeInstancia("");
            fetchGrupos();
        }
    }, [open]);

    async function fetchGrupos() {
        try {
            const res = await api.get("/kanbangrupos");
            if (!res.data.error) {
                setGrupos(res.data);
            }
        } catch {
            console.error("Falha ao carregar grupos");
        }
    }

    async function handleSalvar() {
        if (!idGrupo)
            return AlertInfo({ icon: "info", title: "Selecione um grupo de tarefas" });
        if (!nomeInstancia.trim())
            return AlertInfo({ icon: "info", title: "Informe o nome" });

        setOpenLoad(true);
        try {
            const res = await api.post("/createkanbaninstancia", {
                id_kanban_grupo: idGrupo,
                nome_instancia: nomeInstancia.trim(),
            });

            if (res.data.success) {
                AlertInfo({ icon: "success", title: "Tarefa criada com sucesso!" });
                onSaved();
                onClose();
            } else {
                AlertInfo({ icon: "error", title: res.data.message || "Falha ao criar tarefa" });
            }
        } catch {
            AlertInfo({ icon: "error", title: "Falha na conexão" });
        }
        setOpenLoad(false);
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <SimpleBackdrop open={openLoad} />

            <DialogTitle>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AddTaskIcon color="primary" />
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            Nova Tarefa
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Selecione o grupo e informe o nome
                        </Typography>
                    </Box>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <TextField
                    select
                    label="Grupo de Tarefas *"
                    fullWidth
                    size="small"
                    value={idGrupo}
                    onChange={e => setIdGrupo(Number(e.target.value))}
                    sx={{ mb: 2, mt: 0.5 }}
                >
                    {grupos.map(g => (
                        <MenuItem key={g.id_kanban_grupo} value={g.id_kanban_grupo}>
                            {g.nome_grupo}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    label="Nome *"
                    fullWidth
                    size="small"
                    value={nomeInstancia}
                    onChange={e => setNomeInstancia(e.target.value)}
                    inputProps={{ maxLength: 255 }}
                    onKeyDown={e => {
                        if (e.key === "Enter") handleSalvar();
                    }}
                />
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} color="inherit" variant="outlined">
                    Cancelar
                </Button>
                <Button onClick={handleSalvar} variant="contained" disableElevation>
                    Criar Tarefa
                </Button>
            </DialogActions>
        </Dialog>
    );
}
